<template>
  <div>
    <div class="map-sidebar-overlay d-flex flex-row">
      <div class="map-sidebar flex-grow-1">
        <div class="px-4 mt-2">
          <div class="text-h6 d-flex justify-space-between align-center">
            <div class="text-h6">View Selection</div>
            <div>
              <v-btn
                id="edit-button"
                @click="newSelection"
                :disabled="loading"
                small
                outlined
                title="Edit settings"
              >
                Edit
              </v-btn>
              <v-btn
                v-if="monitorsEnabled"
                id="monitor-button"
                @click="createMonitor"
                :disabled="loading"
                class="ml-4"
                small
                outlined
                title="Create monitor based on the settings"
              >
                Create Monitor
              </v-btn>
            </div>
          </div>
        </div>

        <!--
        height calculation below allows us to keep the title
        and reset/create footer buttons sticky while providing
        a scroll bar if the panels expanded are greater than
        the available height

        64px = app header height
        48px = title height + 8px top margin
        68px = view all tiles/view cart footer height
        20px = padding for top and bottom
      -->
        <div
          style="
            max-height: calc(100vh - (64px + 48px + 68px + 20px));
            overflow: auto;
          "
          class="px-4"
        >
          <v-expansion-panels v-model="panel" accordion focusable multiple tile>
            <v-expansion-panel id="info-panel">
              <v-expansion-panel-header
                >Selection Info</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-responsive
                  class="overflow-y-auto"
                  max-height="400"
                  v-if="Object.keys(select).length > 0"
                >
                  <v-list dense>
                    <v-list-item
                      ><span class="pr-3 text--secondary">{{
                        "Select ID: "
                      }}</span>
                      {{ this.select_id }}</v-list-item
                    >
                    <v-list-item v-if="this.name"
                      ><span class="pr-3 text--secondary">{{ "Name: " }}</span
                      >{{ this.name }}</v-list-item
                    >
                    <v-list-item
                      ><span class="pr-3 text--secondary">{{
                        "Cell Count: "
                      }}</span
                      >{{ this.cell_count }}</v-list-item
                    >
                    <v-list-item v-if="this.tile_count"
                      ><span class="pr-3 text--secondary">{{
                        "Tile Count: "
                      }}</span
                      >{{ this.tile_count }}</v-list-item
                    >
                    <v-list-item
                      ><span class="pr-3 text--secondary">{{
                        "Unique Acquisitions: "
                      }}</span
                      >{{ this.unique_acquisitions.length }}</v-list-item
                    >
                  </v-list>
                  <!-- <v-tabs style="border: 1px solid #4c4b48">
                  <v-tab>Estimated Cost</v-tab>
                  <v-tab-item>
                    <v-data-table
                      :headers="cost_headers"
                      :items="formatNumber([select.usage.cost])"
                      hide-default-footer
                      dense
                    >
                    </v-data-table>
                  </v-tab-item>
                  <v-tab>Estimated Area</v-tab>
                  <v-tab-item>
                    <v-data-table
                      :headers="area_headers"
                      :items="formatNumber([select.usage.area])"
                      hide-default-footer
                      dense
                    >
                    </v-data-table>
                  </v-tab-item>
                </v-tabs> -->
                </v-responsive>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel id="view-filters-panel">
              <v-expansion-panel-header
                >Selection Parameters
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <view-filters
                  :filters="this.select"
                  v-if="Object.keys(select).length > 0"
                ></view-filters>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel
              id="metadata-panel"
              v-if="selected_cell_metadata"
            >
              <v-expansion-panel-header>Cell Metadata</v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  class="mt-4 text-caption"
                  v-html="selected_cell_metadata"
                ></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="pa-4 d-flex justify-space-between highlight">
          <AllTiles
            ref="all_tiles"
            :selectResult="formated"
            :cell_features="this.select_features"
            @view_cart="$refs.shopping_cart.dialog = true"
          />
          <shopping-cart
            ref="shopping_cart"
            :selectResult="formated"
            :select_id="select_id"
            :select_aoi_obj="select_aoi_obj"
            @view_all_tiles="$refs.all_tiles.dialog = true"
          />
        </div>
      </div>
    </div>
    <div v-show="loading" class="map-padded-overlay">
      <div class="text-center pa-2">
        <spinner>{{ this.loading_message }}...</spinner>
      </div>
    </div>
    <div v-show="acquisition_loading" class="map-loading-overlay">
      <div class="text-center pa-2">
        <spinner>Loading acquisition...</spinner>
      </div>
    </div>
    <div
      class="bottom-tile-viewer"
      v-if="
        mounted && map_loaded && !loading && selectHasFeatures && user_details
      "
    >
      <bottom-tile-viewer
        id="row-tiles"
        :cell_feature="get_cell_feature(cell_id)"
        :unique_acquisitions="unique_acquisitions"
        @change="onAcquisitionChange"
        @tabSelected="onTabSelected"
      />
    </div>
    <div
      class="map-bottom-controls"
      v-if="!timelineView && !loading && map_loaded"
    >
      <div class="map-legend-container mt-4 pa-4">
        <v-row align="center" no-gutters>
          <v-col
            cols="6"
            class="flex-grow-0 flex-shrink-1 text-caption text-nowrap"
            ><v-icon class="mr-1" color="white">mdi-map-legend</v-icon>Color
            Results By</v-col
          >
          <v-col>
            <v-select
              v-model="legendStyle"
              :items="legendStyles"
              item-text="label"
              item-value="value"
              menu-props="auto"
              label="Legend Style"
              hide-details
              single-line
              class="flex-grow-1 flex-shrink-0"
              style="
                min-width: 100px;
                max-width: 100%;
                margin-top: 0;
                padding-top: 0;
              "
              @change="onLegendStyleChange"
            ></v-select>
          </v-col>
        </v-row>
        <div
          v-if="Array.isArray(legendEntries) && legendEntries.length > 0"
          class="mt-4 text-caption"
        >
          <div
            v-for="entry in legendEntries"
            :key="entry.text"
            class="d-flex w-100"
            style="justify-content: space-between; align-items: center"
          >
            <div
              class="legend-swatch"
              :style="`background-color: ${entry.color}`"
            ></div>
            <div>{{ entry.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/shared/Spinner";
import * as turf from "@turf/helpers";
import turfBbox from "@turf/bbox";
import turfBboxPolygon from "@turf/bbox-polygon";
import Wkt from "wicket";
import selectApi from "@/api/select";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import ViewFilters from "@/components/ViewFilters.vue";
import ShoppingCart from "@/components/select/ShoppingCart.vue";
import BottomTileViewer from "./BottomTileViewer.vue";
import AllTiles from "@/components/select/AllTiles.vue";
import mapUtils from "@/utils/map";
const uiStore = createNamespacedHelpers("ui");
const cartStore = createNamespacedHelpers("shoppingCart");
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  props: {
    select_request: Object,
    select_response: Object,
    map: {
      type: Object,
      required: true,
    },
    map_loaded: {
      type: Boolean,
      required: true,
    },
    drawnFeature: {
      type: Object,
      default: null,
    },
  },
  mixins: [mapUtils],
  components: {
    Spinner,
    ViewFilters,
    ShoppingCart,
    BottomTileViewer,
    AllTiles,
  },
  computed: {
    ...mapGetters(["user_details", "monitorsEnabled"]),
    selectHasFeatures() {
      return (
        this.select_features &&
        this.select_features.features &&
        this.select_features.features.length > 0
      );
    },
  },
  data() {
    const legendStyles = [
      { label: "Stack Depth", value: "stack_depth" },
      { label: "Tile Depth", value: "tile_count" },
    ];
    const legendEntries = this.getLegendStyle(legendStyles[0].value).entries;
    const empty_features = {
      type: "FeatureCollection",
      features: [],
    };

    return {
      loading: false,
      acquisition_loading: false,
      name: null,
      select: {},
      select_id: "",
      cell_id: null,
      selected_cell_metadata: null,
      panel: [0],
      metadataSourceName: "Select Tiles",
      timelineMetadataSourceName: "Acquisition Tile Outlines",
      drawnPolygonSourceName: "Select AOI",
      cellTextLayerName: "Cell Text Values",
      select_aoi: [],
      select_aoi_obj: {},
      select_features: [],
      cell_count: 0,
      tile_count: 0,
      unique_acquisitions: [],
      stack_depth: 5,
      legendStyle: legendStyles[0],
      legendStyles,
      legendEntries,
      textPropertyName: "available_tiles",
      area_headers: [
        { text: "Fresh (SqKm)", value: "fresh_imagery_sqkm", sortable: false },
        {
          text: "Standard (SqKm)",
          value: "standard_imagery_sqkm",
          sortable: false,
        },
        {
          text: "Training (SqKm)",
          value: "training_imagery_sqkm",
          sortable: false,
        },
        { text: "Total (SqKm)", value: "total_imagery_sqkm", sortable: false },
      ],
      cost_headers: [
        { text: "Fresh ($)", value: "fresh_imagery_cost", sortable: false },
        {
          text: "Standard ($)",
          value: "standard_imagery_cost",
          sortable: false,
        },
        {
          text: "Training ($)",
          value: "training_imagery_cost",
          sortable: false,
        },
        { text: "Total ($)", value: "total_imagery_cost", sortable: false },
      ],
      formated: [],
      mounted: false,
      loading_message: "Loading Selection",
      select_tiles: [],
      current_acquisition_tiles: null,
      empty_features,
      previewImageSourceNames: [],
      currentAcquisitionId: null,
      timelineView: false,
      covering_cells_features: [],
    };
  },
  setup() {
    const { addToCart } = cartStore.useMutations(["addToCart"]);
    const { SHOW_SNACKBAR } = uiStore.useMutations(["SHOW_SNACKBAR"]);
    return { SHOW_SNACKBAR, addToCart };
  },
  mounted() {
    this.$log.debug(`ViewSelect has beeen mounted`);
    this.mounted = true;
    this.initMap();
  },
  beforeDestroy() {
    // remove everything we have drawn
    const sourcesToRemove = [
      {
        name: this.metadataSourceName,
        layersToRemove: [
          this.metadataSourceName,
          `${this.metadataSourceName} Outline`,
          this.cellTextLayerName,
        ],
      },
      {
        name: this.timelineMetadataSourceName,
        layersToRemove: [this.timelineMetadataSourceName],
      },
      {
        name: this.drawnPolygonSourceName,
        layersToRemove: [
          `${this.drawnPolygonSourceName} Fill`,
          `${this.drawnPolygonSourceName} Outline`,
        ],
      },
      { name: "cell-extent", layersToRemove: ["hightlight-cell-bounds"] },
      { name: "hover-extent", layersToRemove: ["hover-cell-bounds"] },
    ];
    sourcesToRemove.forEach((s) => {
      const source = this.map.getSource(s.name);

      // only remove the source and layers if there is a source
      if (source) {
        this.map.removeSourceLayers(s.name, s.layersToRemove);

        // null out data
        source.setData({ type: "FeatureCollection", features: [] });
      }
    }, this);

    // remove preview images if there are any
    this.removePreviewImages(this);
  },
  methods: {
    placeOrder() {
      this.$router.push({
        name: "create-order",
        params: this.select,
      });
    },
    newSelection() {
      this.$router.push({
        name: "Select",
        params: { request_details: this.select },
      });
    },
    createMonitor() {
      this.$router.push({
        name: "create-monitor",
        params: { request_details: this.select },
      });
    },

    initMap() {
      if (this.map_loaded) {
        this.$log.debug(`Map has loaded...`);
        this.loading = true;

        // eslint-disable-next-line
        const me = this;
        const map = this.map;

        // eslint-disable-next-line
        const mapboxgl = require("mapbox-gl");
        const metadataOutlineSourceName = `${this.metadataSourceName} Outline`;

        this.$log.debug(`Setting up sources and layers...`);
        const drawnFillLayerId = `${this.drawnPolygonSourceName} Fill`;
        map.addSourceLayers(
          this.drawnPolygonSourceName,
          {
            type: "geojson",
            data: null,
          },
          [
            {
              id: drawnFillLayerId,
              type: "fill",
              source: this.drawnPolygonSourceName,
              paint: {
                "fill-color": "#FFFF00",
                "fill-outline-color": "#FFFF00",
                "fill-opacity": 0.05,
              },
            },
            {
              id: `${this.drawnPolygonSourceName} Outline`,
              type: "line",
              source: this.drawnPolygonSourceName,
              layout: {},
              paint: {
                "line-color": "#FFFF00",
                "line-width": 3,
              },
            },
          ],
          [
            // Handle click event on a grid item
            {
              type: "click",
              layerId: this.metadataSourceName,
              handler: (e) => {
                const map = e.target;
                map.getCanvas().style.cursor = "";
                showCellMetadata(e.features[0]);
                if (map.getSource("cell-extent")) {
                  map.getSource("cell-extent").setData(e.features[0]);
                } else {
                  map.addSource("cell-extent", {
                    type: "geojson",
                    data: e.features[0],
                  });
                  map.addLayer({
                    id: "hightlight-cell-bounds",
                    type: "line",
                    source: "cell-extent",
                    layout: {},
                    paint: {
                      "line-width": 5,
                      "line-color": "#FCAF17", // maxar primary gold color
                    },
                  });
                }
                this.cell_id = e.features[0].properties.id;
                this.panel = [2];
              },
            },
            // Highlight grid on hover as well as change the cursor to a pointer
            {
              type: "mousemove",
              layerId: this.metadataSourceName,
              handler: (e) => {
                const map = e.target;

                if (me.hoveredSquareId) {
                  map.setFeatureState(
                    { source: me.metadataSourceName, id: me.hoveredSquareId },
                    { hover: false }
                  );
                }

                if (!isNaN(e.features[0].id)) {
                  map.getCanvas().style.cursor = "pointer";

                  me.hoveredSquareId = e.features[0].id;
                  map.setFeatureState(
                    { source: me.metadataSourceName, id: me.hoveredSquareId },
                    { hover: true }
                  );

                  if (map.getSource("hover-extent")) {
                    map.getSource("hover-extent").setData(e.features[0]);
                  } else {
                    map.addSource("hover-extent", {
                      type: "geojson",
                      data: e.features[0],
                    });
                    map.addLayer({
                      id: "hover-cell-bounds",
                      type: "line",
                      source: "hover-extent",
                      layout: {},
                      paint: {
                        "line-width": 3,
                        "line-color": "#026AE3", // maxar secondary link color
                      },
                    });
                  }
                } else {
                  map.getCanvas().style.cursor = "";

                  if (map.getSource("hover-extent")) {
                    map.getSource("hover-extent").setData(this.empty_features);
                  }
                }
              },
            },
            // Remove highlight when we leave a grid item as well as clear the cursor style
            {
              type: "mouseleave",
              layerId: this.metadataSourceName,
              handler: (e) => {
                const map = e.target;
                map.getCanvas().style.cursor = "";

                if (me.hoveredSquareId) {
                  map.setFeatureState(
                    { source: me.metadataSourceName, id: me.hoveredSquareId },
                    { hover: false }
                  );
                }

                if (map.getSource("hover-extent")) {
                  map.getSource("hover-extent").setData(this.empty_features);
                }

                me.hoveredSquareId = null;
              },
            },
          ]
        );

        map.addSourceLayers(
          this.metadataSourceName,
          {
            type: "geojson",
            data: null,
          },
          [
            {
              id: this.metadataSourceName,
              type: "fill",
              source: this.metadataSourceName,
              paint: {
                "fill-color": me.getLegendStyle(me.legendStyle.value).fillColor,
                "fill-opacity": [
                  "case",
                  ["boolean", ["feature-state", "hover"], false],
                  0.9,
                  0.8,
                ],
              },
            },
            {
              id: metadataOutlineSourceName,
              type: "line",
              source: this.metadataSourceName,
              layout: {},
              paint: {
                "line-color": "rgba(204, 204, 204, 0.8)", // default to 80% opaque gray
                "line-width": 3,
              },
            },
            {
              minzoom: 8,
              id: this.cellTextLayerName,
              type: "symbol",
              source: this.metadataSourceName,
              layout: {
                "text-field": ["get", this.textPropertyName],
                "text-variable-anchor": ["center"],
                "text-radial-offset": 0.0,
                "text-justify": "auto",
                "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
              },
              paint: {
                "text-color": "rgba(255, 255, 255, 1.0)",
                "text-halo-color": "rgba(0, 0, 0, 1.0)",
                "text-halo-width": 1,
              },
            },
          ]
        );

        map.addSourceLayers(
          this.timelineMetadataSourceName,
          {
            type: "geojson",
            data: null,
          },
          [
            {
              id: this.timelineMetadataSourceName,
              type: "line",
              source: this.timelineMetadataSourceName,
              layout: {},
              paint: {
                "line-color": "rgba(204, 204, 204, 0.8)", // default to 80% opaque gray
                "line-width": 3,
              },
            },
          ]
        );

        const showCellMetadata = (feature) => {
          const featureProperties = {
            id: { label: "ID", type: "string" },
            available_tiles: { label: "Available Tiles", type: "number" },
            stack_depth_fulfilled: {
              label: "Stack Depth Reached",
              type: "boolean",
            },
            datetime_min: {
              label: "Oldest Acquisition Date",
              type: "date",
            },
            datetime_max: {
              label: "Newest Acquistion Date",
              type: "date",
            },
          };

          const formatValue = (type, value) => {
            switch (type) {
              case "number":
                return Number(value).toLocaleString();
              case "percent":
                return `${value}%`;
              case "date":
                return new Date(value).toLocaleString();
              case "array":
                return value.join(",");
            }
            return value;
          };

          const description = Object.entries(feature.properties).reduce(
            (accumulator, featureProperty) => {
              const propName = featureProperty[0];
              return propName in featureProperties
                ? accumulator.concat(
                    `<div><span class="text--secondary">${
                      featureProperties[propName].label
                    }:&nbsp;</span>${formatValue(
                      featureProperties[propName].type,
                      featureProperty[1]
                    )}</div>`
                  )
                : accumulator;
            },
            ""
          );

          this.selected_cell_metadata = description;
        };

        this.$log.debug(`Finished setting up map sources and layers...`);
        this.get_select();
      } else {
        setTimeout(this.initMap, 200);
      }
    },

    getFillStackDepth() {
      const legend_entries = [
        { color: "rgba(247, 252, 245, .1)", text: "No Data" },
        { color: "rgba(33, 113, 181, .75)", text: "Less Than Stack Depth" },
        { color: "rgba(0, 68, 27, .9)", text: "Stack Depth Reached" },
      ];
      const light_gradient = "rgba(198, 219, 239, .3)";
      // handle stack depth of 1 edge case
      if (this.stack_depth === 1) {
        return {
          entries: legend_entries,
          fillColor: [
            "interpolate",
            ["linear"],
            ["get", "available_tiles"],
            0,
            ["to-color", legend_entries[0].color],
            1,
            ["to-color", legend_entries[2].color],
          ],
        };
      }
      // handle stack depth of 2 edge case
      if (this.stack_depth === 2) {
        return {
          entries: legend_entries,
          fillColor: [
            "interpolate",
            ["linear"],
            ["get", "available_tiles"],
            0,
            ["to-color", legend_entries[0].color],
            1,
            ["to-color", legend_entries[1].color],
            2,
            ["to-color", legend_entries[2].color],
          ],
        };
      }

      return {
        entries: legend_entries,
        fillColor: [
          "interpolate",
          ["linear"],
          ["get", "available_tiles"],
          0,
          ["to-color", legend_entries[0].color],
          1,
          ["to-color", light_gradient],
          this.stack_depth - 1,
          ["to-color", legend_entries[1].color],
          this.stack_depth,
          ["to-color", legend_entries[2].color],
        ],
      };
    },

    getFillTileCount() {
      const legend_entries = [
        { color: "rgba(180, 220, 180, .1)", text: "No Data" },
        { color: "rgba(00, 180, 44, .3)", text: "1-5" },
        { color: "rgba(00, 180, 44, .5)", text: "5-10" },
        { color: "rgba(00, 255, 00, .75)", text: "10-20" },
        { color: "rgba(00, 255, 00, .9)", text: "> 20" },
      ];

      return {
        entries: legend_entries,
        fillColor: [
          "interpolate",
          ["linear"],
          ["get", "available_tiles"],
          0,
          ["to-color", legend_entries[0].color],
          1,
          ["to-color", legend_entries[1].color],
          5,
          ["to-color", legend_entries[2].color],
          10,
          ["to-color", legend_entries[3].color],
          25,
          ["to-color", legend_entries[4].color],
        ],
      };
    },

    getLegendStyle(style) {
      switch (style) {
        case "tile_count":
          return this.getFillTileCount();
        case "stack_depth":
          return this.getFillStackDepth();
      }

      return this.getFillStackDepth();
    },

    onLegendStyleChange(style) {
      const legendStyle = this.getLegendStyle(style);
      this.legendEntries = legendStyle.entries;
      this.map.map.setPaintProperty(
        this.metadataSourceName,
        "fill-color",
        legendStyle.fillColor
      );
    },

    parseGeom(geom) {
      if (typeof geom === "string") {
        var wkt = new Wkt.Wkt();
        wkt.read(geom);
        geom = wkt.toJson();
      }
      return geom;
    },

    getPolygon(aoi) {
      return [
        {
          type: "Feature",
          geometry: this.parseGeom(aoi),
        },
      ];
    },

    get_cell_feature(cell_id) {
      function get_feature(feature) {
        if (feature.properties.id === cell_id) {
          return feature;
        }
      }
      if (this.select_features.constructor === Object) {
        var cell_feature = null;
        cell_feature = this.select_features.features.filter(get_feature);
        return cell_feature[0];
      } else {
        return null;
      }
    },

    load_select_aoi(select_request, select_id) {
      this.$log.debug(`loading select aoi...`);
      this.select = select_request;

      this.select_id = select_id;
      this.stack_depth = select_request.stack_depth;
      if (select_request.intersects) {
        this.$log.debug(
          `select request has an intersects object=${JSON.stringify(
            select_request.intersects
          )}`
        );
        this.select_aoi_obj.intersects = select_request.intersects;
        this.select_aoi = this.getPolygon(select_request.intersects);
      } else if (select_request.bbox) {
        this.$log.debug(
          `select request has an bbox object=${JSON.stringify(
            select_request.bbox
          )}`
        );
        this.select_aoi_obj.bbox = select_request.bbox;
        const bboxPolygon = turfBboxPolygon(select_request.bbox);
        this.select_aoi = this.getPolygon(bboxPolygon);
        // geometry needs to be unnested for bboxes
        this.select_aoi[0].geometry = this.select_aoi[0].geometry.geometry;
      }

      if (this.select_aoi && this.select_aoi.length > 0) {
        const aoi = this.select_aoi[0];
        this.$log.debug(
          `We have a select aoi, adding it to the map under source=${
            this.drawnPolygonSourceName
          }. select_aoi=${JSON.stringify(aoi)}`
        );

        this.map.getSource(this.drawnPolygonSourceName).setData(aoi);

        const legendStyle = this.getLegendStyle(this.legendStyle);

        this.map.map.setPaintProperty(
          this.metadataSourceName,
          "fill-color",
          legendStyle.fillColor
        );

        this.$log.debug(
          `Added select aoi to the map and set color to ${legendStyle.fillColor}`
        );
      } else {
        this.$log.debug(`No select aoi to load...`);
      }
    },

    async get_select() {
      this.$log.debug(`Getting select...`);
      if (this.select_response) {
        this.$log.debug(
          `We already have a select_response=${JSON.stringify(
            this.select_response
          )}`
        );
        this.select_tiles = JSON.parse(JSON.stringify(this.select_response));
        this.load_select_aoi(
          this.select_request,
          this.select_response.query_id
        );

        await this.load_select_features(
          this,
          this.select_request,
          this.select_response
        );
      } else {
        this.$log.debug(
          `Getting select info with view=${this.$route.query.view}...`
        );
        selectApi
          .get_select_info(this.$route.query.view)
          .then((info_response) => {
            this.$log.debug(
              `Retrieved select info=${JSON.stringify(info_response)}`
            );
            this.load_select_aoi(
              info_response.data.tile_query.criteria,
              info_response.data.tile_query.query_id
            );

            this.select_loading_messages();

            const includeP3drProp = _.get(
              info_response,
              "data.tile_query.criteria.query.p3dr_support.eq",
              null
            );

            this.$log.debug(`Re-running select...`);
            selectApi
              .rerun_select(
                this.$route.query.view,
                "stac",
                includeP3drProp ? "&include_property=p3dr_support" : ""
              )
              .then(async (rerun_response) => {
                this.$log.debug(`Successfully reran select...`);
                this.select_tiles = JSON.parse(
                  JSON.stringify(rerun_response.data)
                );
                this.$log.debug(
                  `select_tiles=${JSON.stringify(this.select_tiles)}`
                );
                await this.load_select_features(
                  this,
                  info_response.data.tile_query.criteria,
                  rerun_response.data
                );
              })
              .catch((err) => {
                this.$log.error(
                  `Failed to load select features with criteria=${JSON.stringify(
                    info_response.data.tile_query.criteria
                  )}, error=${err.toString()}`
                );
              });
          })
          .catch((err) => {
            this.$log.error(
              `Failed to get select info for view=${
                this.$route.query.view
              }, error=${err.toString()}`
            );
          });
      }
    },

    select_loading_messages() {
      let delay = 1000;
      for (let count = 0; count < 10; count++) {
        setTimeout(() => {
          if (
            this.loading_message.startsWith("Loading Selection") ||
            this.loading_message.startsWith("Gathering matching images")
          ) {
            this.loading_message = `Gathering matching images (${count}/10)`;
          }
        }, delay);
        delay += 2000;
      }
    },

    onAcquisitionChange(acq_id) {
      this.$log.debug(`New acquisition selected: ${acq_id}`);
      this.viewAcquisition(acq_id);
    },

    onTabSelected(tab) {
      if (tab === 0) {
        this.onTilesTabSelected();
      } else if (tab === 1 && this.currentAcquisitionId) {
        this.viewAcquisition(this.currentAcquisitionId);
      }
    },

    onTilesTabSelected() {
      this.timelineView = false;

      // show layers
      this.map.showLayer(`${this.cellTextLayerName}`);
      this.map.showLayer(`${this.metadataSourceName}`);
      this.map.showLayer(`${this.metadataSourceName} Outline`);

      this.map.hideLayer(`${this.timelineMetadataSourceName}`);

      // show the previously selected cell feature
      const cellFeature = this.get_cell_feature(this.cell_id);
      if (this.map.getSource("cell-extent") && cellFeature) {
        this.map.getSource("cell-extent").setData(cellFeature);
      }

      this.hidePreviewImages();

      // reorder layers
      this.map.moveLayer(`${this.drawnPolygonSourceName} Fill`);
      this.map.moveLayer(`${this.drawnPolygonSourceName} Outline`);
      this.map.moveLayer(this.metadataSourceName);
      this.map.moveLayer(`${this.metadataSourceName} Outline`);
      this.map.moveLayer(`${this.cellTextLayerName}`);
      this.map.moveLayer("hover-cell-bounds");
      this.map.moveLayer("hightlight-cell-bounds");
    },

    onTimelineTabSelected() {
      this.timelineView = true;
      this.map.hideLayer(`${this.cellTextLayerName}`);
      this.map.hideLayer(`${this.metadataSourceName}`);
      this.map.hideLayer(`${this.metadataSourceName} Outline`);

      this.map.showLayer(`${this.timelineMetadataSourceName}`);

      // hides the selected grid item
      if (this.map.getSource("cell-extent")) {
        this.map.getSource("cell-extent").setData(this.empty_features);
      }

      this.showPreviewImages();
    },

    hidePreviewImages() {
      this.previewImageSourceNames.forEach((sourceName) => {
        this.map.hideLayer(`${sourceName}-id`);
      });
    },

    showPreviewImages() {
      this.previewImageSourceNames.forEach((sourceName) => {
        this.map.showLayer(`${sourceName}-id`);
      });
    },

    viewAcquisition(acq_id) {
      this.currentAcquisitionId = acq_id;
      this.acquisition_loading = true;
      this.removePreviewImages(this);
      if (this.map.getSource("cell-extent")) {
        this.map.getSource("cell-extent").setData(this.empty_features);
      }

      this.onTimelineTabSelected();

      const current_acquisition_tiles = {
        type: "FeatureCollection",
        features: [],
      };

      const select_tiles_in_acquisition = this.select_tiles.features.filter(
        (f) => _.get(f, "properties.acquisition_id", null) === acq_id
      );
      this.$log.debug(
        `found ${select_tiles_in_acquisition.length} select tile within the current acquisition=${acq_id}`
      );

      select_tiles_in_acquisition.forEach((f) => {
        const cell_id = f.properties.cell_id;

        this.covering_cells_features.every((c) => {
          this.$log.debug(
            `does select tile cell_id=${cell_id} match covering cell id=${c.properties.id}?`
          );

          if (c.properties.id === cell_id && c.geometry) {
            this.$log.debug(`found MATCH!`);
            current_acquisition_tiles.features.push({
              ...f,
              geometry: c.geometry,
            });

            return false;
          }

          return true;
        }, this);
      }, this);

      this.current_acquisition_tiles = current_acquisition_tiles;
      this.$log.debug(
        `plotting ${current_acquisition_tiles.features.length} tiles within the current acquisition=${acq_id}`
      );
      this.map
        .getSource(this.timelineMetadataSourceName)
        .setData(current_acquisition_tiles);
      this.previewImageSourceNames = this.addPreviewImages(
        current_acquisition_tiles.features,
        this.map,
        [
          `${this.metadataSourceName} Outline`,
          `${this.drawnPolygonSourceName} Fill`,
          this.metadataSourceName,
          `${this.drawnPolygonSourceName} Outline`,
          "hover-cell-bounds",
          "hightlight-cell-bounds",
        ],
        this.timelineMetadataSourceName
      );

      this.$nextTick(() => {
        this.acquisition_loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.map-bottom-controls {
  position: absolute;
  right: 5px;
  bottom: 100px;
  width: 25%;
  max-width: 350px;
}

.bottom-tile-viewer {
  position: absolute;
  left: -140px;
  bottom: 50px;
  width: 25%;
  max-width: 350px;
  z-index: 4;
}
</style>
